import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Doughnut } from 'react-chartjs-2'
import { v4 as uuidv4 } from 'uuid'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { useSelector } from 'react-redux'

import GraphContainer from '../../GraphContainer'

import { useSroiFilters } from '../../../SroiFiltersContext'
import { generateImpactPathwaysData } from './impactPathwaysHelpers'
import { getHtmlLegendPlugin } from '../../../../plugins'
import { getOptions } from './options'
import { hasChartData } from '../helpers/chartDataHelpers'

import { socialReturnOnInvestmentReportSelector } from '../../../../../../modules/selectors/socialReturnOnInvestment'

import { gridCharts, helpTexts } from '../../../constants'

import useStyles from './styles'

const ImpactPathways = () => {
  const classes = useStyles()
  const { t } = useTranslation()
  const { selectedRegion, selectedStakeholder } = useSroiFilters()

  const report = useSelector(socialReturnOnInvestmentReportSelector)

  const graphData = useMemo(() => {
    return generateImpactPathwaysData({
      selectedRegion,
      selectedStakeholder,
      report
    })
  }, [selectedRegion, selectedStakeholder, report])

  const legendContainerId = useMemo(() => uuidv4(), [])

  const options = useMemo(() => getOptions(legendContainerId), [legendContainerId])

  const plugins = useMemo(() => {
    const htmlLegendPlugin = getHtmlLegendPlugin()

    return [htmlLegendPlugin, ChartDataLabels]
  }, [])

  // Don't render chart if there's no data
  if (!hasChartData(graphData)) {
    return null
  }

  return (
    <GraphContainer
      id={gridCharts.sroiImpactPathways}
      title={t('Impact by pathway')}
      className={classes.graphContainer}
      headingContainerClassName={classes.headingContainer}
      helpText={helpTexts.impactByPathway}
    >
      <div className={classes.graphWrapper}>
        <div className={classes.legendContainer} id={legendContainerId}>
          {/*// The legend of the graph will be rendered here by the plugin*/}
        </div>
        <div>
          <Doughnut data={graphData} options={options} plugins={plugins} />
        </div>
      </div>
    </GraphContainer>
  )
}

export default ImpactPathways
